import React from 'react'
import {OrderCard, SummaryItem} from '../../shared'
import RefundInput from './RefundInput'
import {deliveryTypes} from 'app/constant'

interface Props {
  subtotalPrice: number | any
  shippingPrice: number | any
  totalDiscounts: number | any
  wineClubDiscounts: number | any
  orderDeliveryMethod: string
  totalPrice: number | any
  onRefundAmountChange: (val: any) => void
  maxRefundPrice: number | any
  totalTax: number | any
  shippingRefundPrice: number | any
  title?: string | any
}

export const Refund: React.FC<Props> = ({
  subtotalPrice,
  wineClubDiscounts,
  shippingPrice,
  totalDiscounts,
  orderDeliveryMethod,
  totalTax,
  onRefundAmountChange,
  shippingRefundPrice,
  title = 'Refund Summary',
  ...props
}) => {
  return (
    <OrderCard
      title={title}
      isCustomFooter={
        <div className='card-footer mb-0'>
          <SummaryItem
            title={props.totalPrice >= 0 ? 'Total Refund Amount' : 'Total Charge Amount'}
            value={props.totalPrice >= 0 ? props.totalPrice : props.totalPrice * -1}
            isValueBolder
            isTitleBolder
            isBetween
          />
        </div>
      }
    >
      {orderDeliveryMethod === deliveryTypes.ship && (
        <RefundInput
          {...props}
          refundPrice={shippingRefundPrice}
          onAmountChange={onRefundAmountChange}
          className='mb-5'
        />
      )}
      <SummaryItem title='Subtotal' value={subtotalPrice} isBetween />
      {wineClubDiscounts > 0 && (
        <SummaryItem title='Wine Club Discount' value={wineClubDiscounts} isBetween isDiscount />
      )}
      {totalDiscounts > 0 && (
        <SummaryItem title='Discount' value={totalDiscounts} isBetween isDiscount />
      )}
      {orderDeliveryMethod === deliveryTypes.ship && (
        <SummaryItem title='Shipping Fee' value={shippingPrice} isBetween />
      )}
      <SummaryItem title='Tax' value={totalTax} isBetween />
    </OrderCard>
  )
}

export default Refund
